module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_8003.67a423cc.png";